import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { UserPlantRole } from '../../interfaces/user-plant-role.interface';

@Injectable({
  providedIn: 'root',
})
export class UserPlantRoleService {
  private readonly http = inject(HttpClient);

  getUserRoles(userId: string): Observable<UserPlantRole[]> {
    return this.http.get<UserPlantRole[]>(`/api/user-plant-roles/${userId}`);
  }

  bulkUpdateUserPlantRoles(payload: {
    userIds: string[];
    assignments: UserPlantRole[];
  }): Observable<boolean> {
    return this.http.post<boolean>(
      '/api/user-plant-roles/bulk-update',
      payload,
    );
  }
}
